// removed by extract-text-webpack-plugin
module.exports = {"raffle-info":"raffle-info__3U1i0","raffle-info-image":"raffle-info-image__1d_v9","raffle-info-text":"raffle-info-text__27DC8","raffle":"raffle__1pmB_","currency":"currency__30dVy","price":"price__3TOP1","currencyCode":"currencyCode__Msb6P","sizeLabel":"sizeLabel__1pP6q","sizeValue":"sizeValue__1RRL0","size":"size__DyWe5","brand":"brand__3iPNB","name":"name__1s4PF","type":"type__oB0OM","shipping":"shipping__2v0BD"};


//////////////////
// WEBPACK FOOTER
// ./components/blocks/raffleForm/styles/RaffleInfo.scss
// module id = ONTI
// module chunks = 1